export enum Modifier {
  NULL = '',
  ACTIVE = 'active',
  SCROLL = 'scrolled',
  DEPRECATED = 'deprecated'
}
export enum Language {
  EN = 'en',
  ZH = 'zh'
}
export enum SkillType {
  BACKEND = 'backend',
  FRONTEND = 'frontend',
  DEVOPS = 'devOps'
}
